import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
import { environment } from '../environments/environment';

interface ApiResponse<T> {
    obj: T;
    message?: string;
    success?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private baseUrl = environment.apiUrl.endsWith('/') ? environment.apiUrl : `${environment.apiUrl}/`;

    constructor(
        private http: HttpClient,
        private userService: UserService
    ) {}

    /**
     * GET request
     * @param object API object (e.g., 'feed', 'places')
     * @param action API action (e.g., 'get', 'list')
     * @param extra Additional query parameters
     */
    get<T>(object: string, action: string, extra: string = ''): Observable<ApiResponse<T>> {
        const user = this.userService.get();
        let url = `${this.baseUrl}${object}/${action}?code=${user?.wechatid || ''}`;
        if (extra) {
            url += extra;
        }
        return this.http.get<ApiResponse<T>>(url);
    }

    /**
     * POST request
     * @param object API object
     * @param action API action
     * @param data Request body
     */
    post<T>(object: string, action: string, data: any): Observable<ApiResponse<T>> {
        const user = this.userService.get();
        const url = `${this.baseUrl}${object}/${action}?code=${user?.wechatid || ''}`;
        return this.http.post<ApiResponse<T>>(url, data);
    }

    /**
     * PUBLIC POST request - no authentication required
     * Used for public endpoints that don't need user code
     * @param object API object
     * @param action API action
     * @param data Request body
     */
    postPublic<T>(object: string, action: string, data: any): Observable<ApiResponse<T>> {
        const url = `${this.baseUrl}${object}/${action}`;
        return this.http.post<ApiResponse<T>>(url, data);
    }
}
